import { Fragment } from "react";
// import { useTranslation } from "react-i18next";
// import { useDispatch, useSelector } from "react-redux";
// import { getAboutSite, getAboutPhoto } from "../../store/about/aboutAction";
// import { baseUrl } from "../../utils/APi";
// import Loader from "../../component/Loader";
import WhoWE from "./RegisterNow";
import BestCompany from "./BestCompany";
import RegisterNow from "./RegisterNow";
import BreadBanner from "../../component/BreadBanner";
import bg from "../../assets/image/01.jpg";
import ApplyFor from "../home/ApplyFor";
import Teams from "./Teams";
import Partners from "./Partners";

const About = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { aboutSite, aboutPhoto, loading } = useSelector(
  //   (state) => state.aboutSlicer
  // );
  // const stripHtmlTags = (html) => {
  //   const doc = new DOMParser().parseFromString(html, "text/html");
  //   return doc.body.textContent || "";
  // };
  // const aboutSiteText = stripHtmlTags(aboutSite ? aboutSite :"");
  // useEffect(() => {
  //   dispatch(getAboutSite(lan));
  //   dispatch(getAboutPhoto());
  // }, [dispatch, lan]);

  return (
    <Fragment>
      <BreadBanner title={"About"} bg={bg} />
      <BestCompany />
      <ApplyFor />
      <Teams />
      <RegisterNow />
      <Partners />
    </Fragment>
  );
};

export default About;
